export default __webpack_public_path__ + "static/media/shot.15ff2950.png";